import { render, staticRenderFns } from "./menu-tree.vue?vue&type=template&id=7db25fb6&scoped=true&"
import script from "./menu-tree.vue?vue&type=script&lang=js&"
export * from "./menu-tree.vue?vue&type=script&lang=js&"
import style0 from "./menu-tree.vue?vue&type=style&index=0&id=7db25fb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db25fb6",
  null
  
)

component.options.__file = "menu-tree.vue"
export default component.exports